export const selectOpportunities = (state) => state.nestedOpportunities.data;
export const selectIsLoading = (state) => state.nestedOpportunities.requestStarted;
export const selectMeta = (state) => state.nestedOpportunities.meta;
export const selectParams = (state) => state.nestedOpportunities.params;
export const selectIsRefreshRequired = (state) => state.nestedOpportunities.isRefreshRequired;
